<template>
    <div class="deliverable-value-item visible-row" :class="{ 'visible-row--invisible': !visible }">
        <div v-if="canChangeVisibility" class="visible-row__eye">
            <Icon v-if="visible" type="ios-eye" @click="toggleVisibility" />
            <Icon v-else type="ios-eye-off" @click="toggleVisibility" />
        </div>
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "VisibleRow",
    props: {
        canChangeVisibility: {
            type: Boolean,
            default: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },

    emits: ["updateSettings"],

    methods: {
        toggleVisibility() {
            this.$emit("updateSettings", { visible: !this.visible });
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.visible-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex: 1 0;

    &--invisible {
        color: $cmp-dark-disabled-color;
    }

    &__eye {
        cursor: pointer;
        text-align: center;
        color: $cmp-dark-font-color;
        border-right: 1px solid $cmp-dark-bg-color;
        padding: 0 10px;
    }
}
</style>
